import addMonths from 'date-fns/addMonths';
import React from 'react';

import { formatDate, useRequiredParams } from 'utils';
import { useAccountGroupProfileWithAumIncluded } from 'views/portfolio/account-aum-queries';
import { useEstimatedEpwTaxRates } from 'views/portfolio/tax-profile-queries';

import { WithdrawalTaxRateOverride } from './WithdrawalTaxRateOverride';

export const AdvancedTaxRates = () => {
    const { accountGroupGUID } = useRequiredParams(['accountGroupGUID']);
    const { data: accountGroupProfile } = useAccountGroupProfileWithAumIncluded(accountGroupGUID);
    const optimizationHorizonMonths = accountGroupProfile?.accountGroup.optimizationHorizonMonths ?? 0;
    const accountGroup = accountGroupProfile?.accountGroup;
    const customTaxRate = accountGroup?.withdrawalTaxRate;

    const startDate = formatDate(new Date(), 'SERVER');
    const endDate = accountGroup?.targetEndDate
        ? accountGroup.targetEndDate
        : formatDate(addMonths(new Date(), optimizationHorizonMonths), 'SERVER');

    const { data, isLoading } = useEstimatedEpwTaxRates(accountGroupGUID, startDate, endDate);

    const taxDetailsArray = data?.taxDetails ? Object.entries(data.taxDetails) : [];

    return (
        <div className="space-y-3">
            <WithdrawalTaxRateOverride />
            <div className="border-border rounded-lg border bg-white p-4">
                {isLoading ? (
                    <div className="text-sm text-gray-500">Loading...</div>
                ) : taxDetailsArray.length === 0 ? (
                    <div className="text-sm text-gray-500">No tax rate data available</div>
                ) : (
                    <div className="space-y-1">
                        <div className="border-border flex justify-between border-b pb-1 text-xs font-semibold text-gray-700">
                            <span>Year</span>
                            <span>Withdrawal Tax Rate</span>
                        </div>
                        {taxDetailsArray.map(([year, details]) => {
                            const displayRate =
                                customTaxRate !== undefined
                                    ? (Number(customTaxRate) * 100).toFixed(2)
                                    : (Number(details.taxRate) * 100).toFixed(2);
                            return (
                                <div key={year} className="flex justify-between text-sm">
                                    <span className="text-gray-600">{year}</span>
                                    <span className="text-cocoa-1000 font-medium">{displayRate}%</span>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};
